/* Build-time feature flags.
 *
 * CRA inlines process.env.REACT_APP_* at build time, so these are constants in
 * the bundle, not runtime lookups — a flag that is off costs nothing.
 */

/* Early access. While this is on, the sign-up calls to action open the
 * waitlist dialog instead of creating an account: the tables are not open yet
 * and a stranger who signs up has nothing to do.
 *
 * Signing IN is unaffected, so existing beta accounts work normally.
 *
 * On everywhere unless explicitly turned off, which is how you reach the real
 * Cognito sign-up flow to test it:
 *
 *   REACT_APP_EARLY_ACCESS=false npm start --prefix frontend
 */
export const EARLY_ACCESS = process.env.REACT_APP_EARLY_ACCESS !== 'false';
